module.exports = __webpack_public_path__ + "media/images/home/rain_product_map-6f63e9f55565ca301724cf47c9353a92.png";